import React, { useState } from 'react';
import axios from 'axios';
import './index.css';

const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const sendMessage = async () => {
    if (!input.trim()) return;

    setMessages((prevMessages) => [
      ...prevMessages,
      { text: input, isUser: true },
    ]);

    setInput(""); // Clear input field
    setLoading(true);

    try {
      // Make an API call to the backend to process the message and store it in the database
      const response = await axios.post('https://apiqms.shigjeta.com/api/chat', {
        messages: [{ role: "user", content: input }],
      });

      // Add bot response to the chat
      const botResponse = response.data.choices[0].message.content;

      setMessages((prevMessages) => [
        ...prevMessages,
        { text: botResponse, isUser: false },
      ]);

      // Optionally, store chat messages to a database via your backend here
      await axios.post('https://apiqms.shigjeta.com/submit', {
        name: 'User', // You can dynamically add user info here if needed
        email: 'user@example.com', // Same for email
        details: input, // User's message
      });
      
    } catch (error) {
      console.error("Error fetching bot response:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: "Sorry, something went wrong. Please try again.", isUser: false },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chatbot-container">
      <div className="chatbot-messages">
        {messages.map((msg, idx) => (
          <div key={idx} className={msg.isUser ? "user-message" : "bot-message"}>
            {msg.text}
          </div>
        ))}
        {loading && <div className="bot-message">Typing...</div>}
      </div>
      <input
        type="text"
        value={input}
        onChange={handleInputChange}
        placeholder="Ask me anything..."
      />
      <button onClick={sendMessage} disabled={loading}>
        Send
      </button>
    </div>
  );
};

export default Chatbot;